import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bpg-membership-preview-success',
  templateUrl: './bpg-membership-preview-success.component.html',
  styleUrls: ['./bpg-membership-preview-success.component.css']
})
export class BpgMembershipPreviewSuccessComponent implements OnInit {

  constructor(
    ) { }

  ngOnInit() {

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    },500);
    

        
    setTimeout(function() { 
      this.router.navigate(['/user-membership']);  
    }.bind(this), 3000); 
  }
  
}
